import React, { useMemo } from 'react';

import { BlankPicker } from '../../../../blank-picker/blank-picker.component';
import BlankTextInput from '../../../../blank-text-input/blank-text-input';
import { useDibContext } from '../use-dib-store';

interface DibInputParams {
  type: 'text' | 'select';
  index: number;
  correctAnswer: string;
}

export function DibInput({
  type = 'select',
  index,
  correctAnswer,
}: DibInputParams) {
  const {
    store: { userAnswers, areErrorsVisible, possibleAnswers, complete },
    actions: { setAnswer },
  } = useDibContext();

  const { answer, correct } = userAnswers[index] ?? { correct: false };

  const isActive = useMemo(() => {
    return (
      userAnswers.slice(0, index).every((val) => val !== null) &&
      !userAnswers[index]
    );
  }, [userAnswers, index]);

  if (type === 'text') {
    return (
      <BlankTextInput
        value={answer}
        hasErrors={areErrorsVisible && !correct}
        isComplete={complete}
        onChangeText={(text) => setAnswer(index, text, correctAnswer)}
      />
    );
  }

  return (
    <BlankPicker
      index={index}
      isCorrect={answer === correctAnswer}
      isResultVisible={areErrorsVisible}
      isActive={isActive}
      setResult={(_, result) => setAnswer(index, result, correctAnswer)}
      options={possibleAnswers}
      word={answer}
      isResultFinal={complete}
    />
  );
}
